export const VIDEO_SERVICE_YOUTUBE = 'youtube'
export const VIDEO_SERVICE_YOUKU = 'youku'
export const VIDEO_SERVICE_LOCAL = 'local'
